'use strict';var _globals=require('./lib/utils/globals');_globals.global.probe={};
//# sourceMappingURL=init.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/probe.gl/dist/init.js
// module id = 455
// module chunks = 0